import { RootState } from '@store/redux/store';

export function selectTiming() {
  return (reduxState: RootState) => {
    return reduxState.filter.timing;
  };
}
